import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import { TenantDataFormatDTO } from 'src/app/models/Tenant/Tenant.model';

@Component({
  selector: 'app-wetstock-card',
  templateUrl: './wetstock-card.component.html',
  styleUrls: ['./wetstock-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class WetstockCardComponent implements OnInit, OnChanges {
  @Input() warehouse: any;
  @Input() showDetails: boolean;
  @Input() tenantDataFormat: TenantDataFormatDTO;
  @Input() selected = false;
  @Input() clickable = true;
  @Input() cardClass: string | string[] = [];

  diffPercent: number | null = null;
  diffColor = '#9E9E9E';

  @Output() select = new EventEmitter<any>();

  get status(): any {
    const stockStatus = this.warehouse?.stockStatus;
    if (Array.isArray(stockStatus)) {
      if (stockStatus.length) {
        return stockStatus[0];
      } 
  
      return {
        warehouse: {
          description: this.warehouse?.description || '--'
        },
        product: {
          description: this.warehouse?.siteProduct?.description || '--',
          unitSymbol: this.tenantDataFormat?.unitOfMeasureVolume?.symbol
        },
        quantity: 0
      };
    }
    return stockStatus ?? null;
  }

  get unitSymbol(): string | undefined {
    return this.status?.product?.unitSymbol || this.tenantDataFormat?.unitOfMeasureVolume?.symbol;
  }

  get lastReadingTimestamp() {
    const timestamp = this.warehouse?.tankStock?.timestamp ?? null
    if (!timestamp) {
      return "--";
    }
    const formatedTimestamp = 
      this.tenantDataFormat?.timezone === 'UTC' 
      ? moment.utc(timestamp).format(this.tenantDataFormat?.datetimeFormat ?? "DD/MM/YYYY HH:mm:ss")
      : moment(timestamp).format(this.tenantDataFormat?.datetimeFormat ?? "DD/MM/YYYY HH:mm:ss");
    
    return formatedTimestamp;
  }

  ngOnInit() {
    this.selected ??= false;
    this.computeDiff();
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.computeDiff();
  }

  onSelect() {
    this.select.emit(this.warehouse);
  }

  private computeDiff() {
    const probe = this.warehouse?.tankStock?.probeNetValue ?? 0;
    const estimated = this.warehouse?.stockStatus[0]?.quantity ?? 0;

    if (!estimated) {
      this.diffPercent = null;
      this.diffColor = '#9E9E9E';
      return;
    }

    const value = ((probe - estimated) / estimated) * 100;
    const abs = Math.abs(value);
    this.diffPercent = value;
    this.diffColor = abs <= 2 ? '#2e7d32' : abs <= 5 ? '#f9a825' : '#c62828';
  }
}
